<script setup>
/******************************************************************************
 * PageComponent: Auth
 *****************************************************************************/
import PageSection from "Components/PageSection/PageSection.vue";
//import PageAuthForm from "./PageAuthForm.vue";
</script>

<template>
    <main class="page">
        <page-section
            hdl="Melden Sie uns einfach online Ihre Zählerstände - schnell, bequem, sicher."
        >
            <p>
                Bitte scannen Sie den QR Code auf der Ablesekarte ein die wir
                Ihnen zugeschickt haben.
            </p>
        </page-section>
    </main>
</template>

<style lang="scss" scoped></style>
